<template>
  <div class="navbar-component">
    <nav class="navbar is-fixed-top" role="navigation" aria-label="main navigation">
      <div class="navbar-brand">
        <a class="navbar-item ml-4 my-1">
          <img src="@/assets/logo.png">
        </a>
      </div>
    </nav>
  </div>
</template>

<script>

export default {

  name: 'navbar'

}

</script>
